export enum MJMLTemplateName {
  Base = 'BASE',
  ResetPassword = 'RESET_PASSWORD',
  SubscriptionDeliveryNotice = 'SUBSCRIPTION_DELIVERY_NOTICE',
  SubscriptionMidweekReminder = 'SUBSCRIPTION_MIDWEEK_REMINDER',
  OrderShipped = 'ORDER_SHIPPED',
  SubscriptionWelcome = 'SUBSCRIPTION_WELCOME',
  SubscriptionPaymentFailed = 'SUBSCRIPTION_PAYMENT_FAILED',
  VerifyEmail = 'VERIFY_EMAIL',
  MedusaResetPassword = 'MEDUSA_RESET_PASSWORD',
  MedusaInviteUser = 'MEDUSA_INVITE_USER',
  MedusaReferralReward = 'MEDUSA_REFERRAL_REWARD',
  MiseClientCampaign = 'MISE_CLIENT_CAMPAIGN'
}
